import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function destroyItem(data) {
  return Axios({
    url: `${baseUrl()}/item/${data.id}`,
    method: "DELETE",
    data: data,
    headers: {
      Authorization:
        `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
    },
  });
}
